import React from 'react';
import { useLocation } from 'react-router-dom';
const pages = {
  '/profile': ['Your space', 'Your entrepreneurial journey', 'Continue your assessment, revisit your results and reflect on what comes next.'],
  '/questions': ['Explore. Assess. Grow.', 'Your assessment', 'Take your time. Answer from your own experience.'],
  '/results': ['Your insights', 'Your mindset profile', 'A starting point for reflection, learning and action.'],
  '/resultdetails': ['Your insights', 'Explore the detail', 'Look more closely at the components of your entrepreneurial mindset.'],
  '/resultextended': ['Your insights', 'Your full report', 'Bring your results together and consider your next steps.'],
  '/admindashboard': ['Administration', 'EntreMap overview', 'Find participants, manage cohorts and explore completion activity.'],
  '/instructor': ['For educators', 'Your cohort workspace', 'Manage your cohorts and explore their reports.'],
  '/studentdashboard': ['Learning together', 'Your cohorts', 'Find your learning groups and their assessments.'],
  '/login': ['Welcome back', 'Continue your journey', 'Sign in with the same account you used for your assessment.'],
  '/teacher-login': ['For educators', 'Sign in to your workspace', 'Access your cohorts and reports.'],
  '/qut-signup': ['Getting started', 'Create your QUT account', 'Keep your assessment and results together in one place.'],
  '/invite': ['Learning together', 'Join your cohort', 'Use the invitation code provided by your educator.'],
  '/surveylanding': ['Before you begin', 'Make space for reflection', 'Allow approximately 15-20 minutes for your assessment.'],
  '/surveycomplete': ['Assessment complete', 'Your next step starts here', 'Explore your results and consider what they mean for you.'],
  '/stripe': ['Explore further', 'Your report options', 'Review the options available for your EntreMap account.'],
  '/error': ['Need a hand?', 'Let’s get you back on track', 'Check the message below or visit our FAQ for help.'],
};
const publicPaths = ['/', '/about', '/contact', '/faq', '/privacypolicy'];
export function isWorkspacePath(pathname) {
  return !publicPaths.includes(pathname.toLowerCase().replace(/\/$/, '') || '/');
}

export default function WorkspaceHeading() {
  const { pathname } = useLocation();
  if (!isWorkspacePath(pathname)) return null;
  const key = pathname.toLowerCase().replace(/\/$/, '');
  const [eyebrow, title, intro] = pages[key] || ['EntreMap', 'Find your next step', 'Explore your entrepreneurial mindset.'];
  return <section id="workspace-content" tabIndex={-1} className={`emap-workspace-heading ${key === '/questions' ? 'emap-workspace-heading--compact' : ''}`}>
    <p className="emap-eyebrow"><span className="emap-eyebrow-line" />{eyebrow}</p>
    <h1>{title}<span>.</span></h1><p>{intro}</p>
  </section>;
}

